import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Spinner } from "@/components/Spinner";
import { toast } from "@/components/ui/sonner";
import { useT } from "@/i18n";

// Handles the Emergent Google OAuth return: the user lands on {origin}/app#session_id=...
// We exchange that session_id for our backend JWT, then land on the dashboard.
export default function AuthCallback() {
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const t = useT();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    // Clean the URL fragment immediately so a reload can't reprocess it.
    window.history.replaceState(null, "", window.location.pathname);

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    loginWithGoogle(sessionId)
      .then(() => {
        toast.success(t("auth.cb_success"));
        navigate("/app", { replace: true });
      })
      .catch(() => {
        toast.error(t("auth.cb_failed"));
        navigate("/login", { replace: true });
      });
  }, [loginWithGoogle, navigate, t]);

  return <Spinner label={t("auth.cb_completing")} />;
}
